import { format } from 'date-fns'

/** Format an ISO datetime string to "HH:mm" (e.g. "14:30") */
export function formatTime(isoDateTime: string): string {
  return format(new Date(isoDateTime), 'HH:mm')
}
